import { LinkComponentContext } from '#pplx/frontend/aether/components/link-component/LinkComponentContext.js';
import { useContext } from 'react';
export function useLinkComponent() {
    return useContext(LinkComponentContext);
}
//# sourceMappingURL=useLinkComponent.js.map